/**
 * Primix Support - PrimeVue Layout Components
 *
 * Registers common layout and utility components.
 */

import LiVue from 'livue';
import { ensurePrimeVueTheme } from './primix.js';

import '../css/index.css';

// PrimeIcons is NOT imported here: Vite lib mode would inline its font files
// as base64 into primix-support.css (~270 KB). It is shipped as a standalone
// stylesheet with external font files (see scripts/build-packages.mjs and
// PrimixSupportServiceProvider::registerAssetsWithLiVue).

// Layout Components
import Card from 'primevue/card';
import Panel from 'primevue/panel';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Fieldset from 'primevue/fieldset';

// Navigation Components
import Menubar from 'primevue/menubar';
import Breadcrumb from 'primevue/breadcrumb';

// Overlay Components
import Popover from 'primevue/popover';
import SmartTooltip from './smart-tooltip';

// Misc Components
import Badge from 'primevue/badge';
import Tag from 'primevue/tag';

const registerSupportComponents = (app) => {
    if (app?.config?.globalProperties?.__primixSupportReady) {
        return;
    }

    app.config.globalProperties.__primixSupportReady = true;

    ensurePrimeVueTheme(app);

    // Layout
    app.component('PCard', Card);
    app.component('PPanel', Panel);
    app.component('PTabs', Tabs);
    app.component('PTabList', TabList);
    app.component('PTab', Tab);
    app.component('PTabPanels', TabPanels);
    app.component('PTabPanel', TabPanel);
    app.component('PFieldset', Fieldset);

    // Navigation
    app.component('PMenubar', Menubar);
    app.component('PBreadcrumb', Breadcrumb);

    // Overlay
    app.component('PPopover', Popover);

    // Directives
    app.directive('tooltip', SmartTooltip);

    // Misc
    app.component('PBadge', Badge);
    app.component('PTag', Tag);
};

LiVue.setup(registerSupportComponents);
